
import { withParams } from 'vuelidate';

export default withParams(
    {
        type: 'password',
        message: 'Geben Sie ein gültiges Passwort ein.',
    },
    (value) => {
        if (!value) {
            return true;
        }

        // Current no validation for passwords
        return true;
    },
);
